import {
  MemeGenerator,
  About,
  SupportUs,
  DataDownloadPage,
  Organization,
  Navbar,
  NavSidebar,
  Individual,
  IndividualEditForm,
  IndividualSubmissionForm,
  ProfilePage,
  NotFound,
  MemeGeneratorOrgWrapper,
  Leaderboard,
} from "./components";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from "./Home";

const RoutesComponent = () => {
  return (
    <Router>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="App">
        <Navbar />
        <div className="below-navbar">
          <NavSidebar />
          <div className="content">
            <Routes>
              {/* <Route element={<PersistLogin />}> */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route
                path="//organization/:orgName"
                element={<Organization />}
              />
              <Route
                path="/memegenerator/:orgName"
                element={<MemeGeneratorOrgWrapper isCustom={false} />}
              />
              <Route
                path="/memegenerator"
                element={<MemeGenerator isCustom={true} />}
              />
              <Route path="/data" element={<DataDownloadPage />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route
                path="/individualSubmission"
                element={<IndividualSubmissionForm />}
              />
              <Route
                path="/individualEdit/:name"
                element={<IndividualEditForm />}
              />
              <Route path="/individual/:name" element={<Individual />} />
              <Route path="/support" element={<SupportUs />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="*" element={<NotFound />} />
              {/* </Route> */}
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
};

export default RoutesComponent;
